const url = {
	// 注册登录
	user_agreementSet: 'user/agreementSet', //用户隐私协议
	sms_send: 'sms/send', //短信验证码
	user_register: 'user/register', //注册申请
	user_setInfo: 'user/setInfo', //设置密码及个人信息
	user_touristLogin: 'user/touristLogin', //设置密码及个人信息
	user_login: 'user/login', //密码登录
	user_mobilelogin: 'user/mobilelogin', //验证码登录
	user_resetpwd: 'user/resetpwd', //重置密码
	user_changemobile: 'user/changemobile', //绑定换绑手机号
	user_applyReport: 'index/applyReport', //申请查看报告详情
	user_logout: 'user/logout', //退出登录
	app_user:'app/user', //绑定APP用户
	app_set:'app/set', //配置信息
	// 答题
	index_grade:'index/grade', //年级列表
	index_record:'index/record', //记录列表
	index_getList: 'index/getList', //题库列表
	index_questionList: 'index/questionList', //试题列表
	index_subQuestion: 'index/subQuestion', //提交试卷
	index_reportData: 'index/reportData', //报告数据
	index_questionLog: 'index/questionLog', //测评记录列表
	user_profile: 'user/profile', //修改年级
	uploadApi: 'upload/uploads', //上传方法
	upReportApi: 'index/upReport', //上传方法
	questionData: 'index/questionData', //答题数据回显--传报告id

}

export default url